(function(angular){
	'use strict';

	angular
		.module('recurringInvestmentModule')
		.controller('RecurringInvestment', [
			'$filter',
			'$q',
			'APP_BASE_PATH',
			'AUTO_INVEST_AMOUNTS',
			'FREQUENCY_OPTIONS',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'InvestmentEntityFactory',
			'moment',
			'MONTHLY_DAY_OPTIONS',
			'SEMI_MONTHLY_DAY_OPTIONS',
			'SettingsFactory',
			'urlFactory',
			RecurringInvestmentLandingFunction
		]);

	function RecurringInvestmentLandingFunction(
		$filter,
		$q,
		APP_BASE_PATH,
		AUTO_INVEST_AMOUNTS,
		FREQUENCY_OPTIONS,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		InvestmentEntityFactory,
		moment,
		MONTHLY_DAY_OPTIONS,
		SEMI_MONTHLY_DAY_OPTIONS,
		SettingsFactory,
		urlFactory
	) {
		var recurringInvestmentLanding = this;

		recurringInvestmentLanding.backLink = function() {
			if (urlFactory.getUrlParam('backLink') === 'settings') {
				return APP_BASE_PATH + '/account/investment-accounts';
			} else if(urlFactory.getUrlParam('backLink') === 'feature') {
				return APP_BASE_PATH + '/features/auto-invest';
			} else if(urlFactory.getUrlParam('backLink') === 'investment-goal') {
				return APP_BASE_PATH + '/investment-goal/invest';
			} else {
				return APP_BASE_PATH + '/account/overview';
			}
		};

		recurringInvestmentLanding.determineFirstInvestment = function() {
			var now = moment();
			var firstDate = moment().date(recurringInvestmentLanding.dayOfMonth.value);
			var firstDateMonthLater = moment().date(recurringInvestmentLanding.dayOfMonth.value).add(1, 'M');
			var dateFormat = 'dddd, MMMM Do YYYY';

			if(recurringInvestmentLanding.frequency.value === 'SEMI_MONTHLY') {
				var secondDate = moment().date(recurringInvestmentLanding.dayOfMonth.value).add(14, 'd');

				if(firstDate.isAfter(now)) {
					recurringInvestmentLanding.firstInvestment = firstDate.format(dateFormat);
				} else if (secondDate.isAfter(now)) {
					recurringInvestmentLanding.firstInvestment = secondDate.format(dateFormat);
				} else {
					recurringInvestmentLanding.firstInvestment = firstDateMonthLater.format(dateFormat);
				}
			} else {
				if(firstDate.isAfter(now)) {
					recurringInvestmentLanding.firstInvestment = firstDate.format(dateFormat);
				} else {
					recurringInvestmentLanding.firstInvestment = firstDateMonthLater.format(dateFormat);
				}
			}

			if(angular.isUndefined(recurringInvestmentLanding.originalInvestment)) {
				recurringInvestmentLanding.originalInvestment = recurringInvestmentLanding.firstInvestment;
			} else {
				if(recurringInvestmentLanding.originalInvestment !== recurringInvestmentLanding.firstInvestment) {
					recurringInvestmentLanding.nextInvestment = recurringInvestmentLanding.firstInvestment;
					recurringInvestmentLanding.showNextInvestment = true;
				} else {
					recurringInvestmentLanding.showNextInvestment = false;
				}
			}
		};

		function initNewForm() {
			recurringInvestmentLanding.paymentMethod = $filter('filter')(recurringInvestmentLanding.paymentMethodOptions, {primaryAccount: true}, true)[0];
			recurringInvestmentLanding.amount = recurringInvestmentLanding.amountOptions[2];
			recurringInvestmentLanding.frequency = recurringInvestmentLanding.frequencyOptions[0];
			recurringInvestmentLanding.dayOfMonthOptions = angular.copy(MONTHLY_DAY_OPTIONS);
			recurringInvestmentLanding.dayOfMonth = recurringInvestmentLanding.dayOfMonthOptions[0];
		}

		function initExistingAmount(initAmount){
			var investmentAmount = initAmount;
			investmentAmount = investmentAmount < recurringInvestmentLanding.minimumInvestment ? recurringInvestmentLanding.minimumInvestment : investmentAmount;
			investmentAmount = investmentAmount > recurringInvestmentLanding.maximumInvestment ? recurringInvestmentLanding.maximumInvestment : investmentAmount;
			recurringInvestmentLanding.amount = {
				value: parseInt(investmentAmount),
				label: $filter('currency')(investmentAmount, '$', 0),
				sortIndex:  parseInt(investmentAmount)
			};
		}

		function initExistingFrequency(initFrequency){
			recurringInvestmentLanding.frequency = $filter('filter')(recurringInvestmentLanding.frequencyOptions, {'value': initFrequency})[0];

			if (recurringInvestmentLanding.frequency.value === "MONTHLY") { 
				recurringInvestmentLanding.dayOfMonthOptions = angular.copy(MONTHLY_DAY_OPTIONS);
			} else {
				recurringInvestmentLanding.dayOfMonthOptions = angular.copy(SEMI_MONTHLY_DAY_OPTIONS);
			}
			recurringInvestmentLanding.dayOfMonth = recurringInvestmentLanding.dayOfMonthOptions[0];
		}

		function initExistingForm() {
			angular.forEach(recurringInvestmentLanding.paymentMethodOptions, function(paymentMethodOption) {
				var selectAccount = recurringInvestmentLanding.activeRecurringInvestmentSchedule.bankAccount.id ? paymentMethodOption.id === recurringInvestmentLanding.activeRecurringInvestmentSchedule.bankAccount.id : paymentMethodOption.primaryAccount === true;

				if(selectAccount) {
					recurringInvestmentLanding.paymentMethod = paymentMethodOption;
				}
			});

			initExistingAmount(recurringInvestmentLanding.activeRecurringInvestmentSchedule.amount);
			initExistingFrequency(recurringInvestmentLanding.activeRecurringInvestmentSchedule.frequency);

			recurringInvestmentLanding.dayOfMonth = $filter('filter')(recurringInvestmentLanding.dayOfMonthOptions, {'value': recurringInvestmentLanding.activeRecurringInvestmentSchedule.firstInvestmentDayOfMonth})[0];
		}

		recurringInvestmentLanding.changePaymentMethod = function() {
			if(recurringInvestmentLanding.paymentMethod.id === "-1") {
				urlFactory.redirect(recurringInvestmentLanding.newBankAccountUrl);
			}
		};

		recurringInvestmentLanding.changeFrequency = function() {
			if(recurringInvestmentLanding.frequency.value === 'SEMI_MONTHLY') {
				recurringInvestmentLanding.dayOfMonthOptions = angular.copy(SEMI_MONTHLY_DAY_OPTIONS);
			} else {
				recurringInvestmentLanding.dayOfMonthOptions = angular.copy(MONTHLY_DAY_OPTIONS);
			}

			recurringInvestmentLanding.dayOfMonth = recurringInvestmentLanding.dayOfMonthOptions[0];
			recurringInvestmentLanding.determineFirstInvestment();
		};

		function buildPayload() {
			return {
				investmentEntityId: INVESTMENT_ENTITY_ID,
				paymentMethodId: Number(recurringInvestmentLanding.paymentMethod.id),
				amount: recurringInvestmentLanding.amount.value,
				frequency: recurringInvestmentLanding.frequency.value,
				firstInvestmentDayOfMonth: recurringInvestmentLanding.dayOfMonth.value
			};
		}

		recurringInvestmentLanding.updateRecurringInvestment = function() {
			SettingsFactory.recurringInvestment.update(buildPayload())
				.then(function(successUrl) {
					urlFactory.redirect(successUrl);
				})
				.catch(function() {
					recurringInvestmentLanding.formSubmitted = false;
				});
		};

		recurringInvestmentLanding.validateRecurringInvestment = function() {
			SettingsFactory.recurringInvestment.validateDetails(buildPayload(), recurringInvestmentLanding.scheduleForm)
				.then(function() {
					urlFactory.submitFormById('recurringInvestmentScheduleForm');
				})
				.catch(function() {
					recurringInvestmentLanding.formSubmitted = false;
				});
		};

		recurringInvestmentLanding.$onInit = function() {
			recurringInvestmentLanding.newBankAccountUrl = globalConfig.newBankAccountUrl;
			recurringInvestmentLanding.loaded = false;
			recurringInvestmentLanding.showNextInvestment = false;
			recurringInvestmentLanding.minimumInvestment = 100;
			recurringInvestmentLanding.maximumInvestment = 250000;
			recurringInvestmentLanding.amountOptions = angular.copy(AUTO_INVEST_AMOUNTS);
			recurringInvestmentLanding.frequencyOptions = angular.copy(FREQUENCY_OPTIONS);

			$q.all({
				setPaymentMethodOptions: InvestmentEntityFactory.getPaymentMethodOptions({includePlaid: true}),
				activeRecurringInvestmentSchedule: SettingsFactory.recurringInvestment.get()
			}).then(function(response) {
				recurringInvestmentLanding.paymentMethodOptions = response.setPaymentMethodOptions;
				recurringInvestmentLanding.loaded = true;

				if(angular.isDefined(response.activeRecurringInvestmentSchedule)) {
					recurringInvestmentLanding.activeRecurringInvestmentSchedule = response.activeRecurringInvestmentSchedule;
					recurringInvestmentLanding.eligibility = response.activeRecurringInvestmentSchedule.eligibility;
					initExistingForm();
				} else {
					initNewForm();
				}

				if(urlFactory.getUrlParam('defaultAmount')){
					initExistingAmount(urlFactory.getUrlParam('defaultAmount'));
				}
				if(urlFactory.getUrlParam('frequency')){
					initExistingFrequency(urlFactory.getUrlParam('frequency'));
				}
				recurringInvestmentLanding.determineFirstInvestment();
			});
		};
	}
})(window.angular);